import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { Messages } from '~src/codegen/Localize';
import { DataAlerts } from '~src/dda/resources/DataAlerts';
import { GenericCard } from '~src/spacesPlatform/components/card/GenericCard';
import { ContentTypeFilterClause,ExplorableItemDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { DataAlertContentType } from '~src/spacesPlatform/models/ContentTypes';

import { getGenericDefaultFilters } from '../../spacesPlatform/contentDefinitions/getDefaultFilters';

export const DataAlertDefinition: ExplorableItemDefinition = {
  itemType: 'dataalert',
  pluralName: Messages.dataAlerts,
  singularName: Messages.dataAlert,
  emptyStateMessage: Messages.dataAlertsEmptyMessage,
  contentFilterKeys: DataAlertContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: GenericCard,
  listViewIconType: null,
  filterClause: ServerFilterClauses.ContentType(['dataalert']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return DataAlerts.all().withExtraParams(DataAlertContentType.extraQueryParams);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list'],
};
